<div class="row">
    <div class="card-columns">
        <div *ngFor="let item of items" class="card card-hover pointer">
          <img src="{{item.image}}" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title"> {{item.name}} </h5>
          </div>
        </div>
    </div>
</div>